import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';
import { useAuthStore } from './stores/authStore';

// 인증서 템플릿 3용 Google Sans Flex 폰트 (CDN 미제공 → self-host).
// Bun 번들러가 CSS 내 url()을 빌드타임에 해석하려다 실패하므로 런타임에 @font-face 주입.
if (typeof document !== 'undefined' && !document.getElementById('google-sans-flex-font')) {
  const style = document.createElement('style');
  style.id = 'google-sans-flex-font';
  style.textContent =
    "@font-face{font-family:'Google Sans Flex';src:url('/fonts/GoogleSansFlex.ttf') format('truetype');font-weight:100 900;font-style:normal;font-display:swap;}";
  document.head.appendChild(style);
}

// 앱 시작 시 서버 세션 확인
useAuthStore.getState().initialize();

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
